<template>
  <v-container fluid grid-list-xl>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">品番詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_SKU_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="cancel">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form v-model="valid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md6 sm6 xs12>
                <div required>
                  <v-text-field
                    :disabled="!!edit"
                    :rules="[(v) => !!v || '品番CD is required']"
                    clearable
                    label="品番CD"
                    v-model.trim="form.code"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-text-field
                  clearable
                  label="品番（海外)CD"
                  v-model="form.supplierCode"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-text-field
                  clearable
                  label="部品名称１"
                  v-model="form.name"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-text-field
                  clearable
                  label="部品名称2"
                  v-model="form.name2"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <remote-autocomplete
                  :label="$t('app.labels.partner')"
                  url="companies/kv?type=PARTNER"
                  v-model="form.partnerId"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <remote-autocomplete
                  :label="$t('app.labels.productCode')"
                  :rules="[(v) => !!v || '品種 is required']"
                  item-text="name"
                  item-value="code"
                  url="products/codes"
                  v-model="form.productCode"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-select
                  :items="$store.state.skuClassifications"
                  label="部品区分CD"
                  v-model="form.type"
                ></v-select>
                <!-- <v-text-field clearable label="部品区分CD" v-model="form.type"/> -->
              </v-flex>
              <v-flex md6 sm6 xs12>
                <remote-autocomplete
                  label="単価外貨"
                  url="currencies/kv"
                  v-model="form.unitPriceCurrencyCode"
                />
              </v-flex>
              <!-- <v-flex md6 sm6 xs12>
                <div required>
                  <v-text-field
                    :rules="[v => !!v || '単価 is required']"
                    clearable
                    label="単価"
                    v-model="form.unitPrice"
                  />
                </div>
              </v-flex>-->
              <v-flex md6 sm6 xs12>
                <v-text-field
                  type="number"
                  clearable
                  label="N/W重量単位"
                  v-model="form.netWeightUnit"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-text-field
                  type="number"
                  clearable
                  label="1個当りのN/W"
                  v-model="form.unitNetWeight"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-text-field
                  type="number"
                  clearable
                  label="箱重量単位"
                  v-model="form.boxWeightUnit"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-text-field
                  type="number"
                  clearable
                  label="箱の重さ"
                  v-model="form.boxWeight"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-text-field
                  type="number"
                  clearable
                  label="入り数"
                  v-model="form.boxQty"
                />
                <v-text-field
                  type="number"
                  clearable
                  label="箱サイズ縦"
                  v-model="form.boxWidth"
                />
                <v-text-field
                  type="number"
                  clearable
                  label="箱サイズ横"
                  v-model="form.boxLength"
                />
                <v-text-field
                  type="number"
                  clearable
                  label="箱サイズ高さ"
                  v-model="form.boxHeight"
                />
                <v-text-field
                  type="number"
                  clearable
                  label="容積単位"
                  v-model="form.boxVolumeUnit"
                />
                <v-text-field
                  type="number"
                  clearable
                  label="箱容積"
                  v-model="form.boxVolume"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      valid: null,
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  methods: {
    save() {
      if (this.valid) {
        this.$http
          .post("/skus", this.form)
          .then(() => {
            this.$router.go(-1);
          })
          .catch((err) => {
            this.$showError(err);
          });
      }
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

